
import { customRef, defineComponent } from 'vue';
// 使用customRef实现debounced的实例
function useDebouncedRef<T>(value: T, delay = 200) {
    let timeOutId: number;
    return customRef((tarck, trigger) => {
        return {
            // 返回数据的
            get() {
                // 告诉Vue追踪数据
                tarck();
                return value;
            },
            // 设置数据
            set(newValue: T) {
                clearTimeout(timeOutId);
                timeOutId = setTimeout(() => {
                    value = newValue;
                    trigger()
                }, delay)
            },
            
        }
    })
}
export default defineComponent({
    name: 'App',
    setup() {
        const keyword = useDebouncedRef('abc', 500);
        return {
            keyword,
        }
    }
});
